import { ShieldCheck, Sparkle, Buildings, Users, ClockCountdown, SealCheck } from "@phosphor-icons/react";

export const VERIF_BADGES = {
  submitted: { label: "Submitted", icon: ClockCountdown, cls: "bg-muted text-muted-foreground" },
  community_suggested: { label: "Community Suggested", icon: Users, cls: "bg-amber-100 text-amber-800" },
  reviewed: { label: "Reviewed", icon: SealCheck, cls: "bg-sky-100 text-sky-800" },
  institution_verified: { label: "Institution Verified", icon: Buildings, cls: "bg-emerald-100 text-emerald-800" },
  family_verified: { label: "Family Verified", icon: ShieldCheck, cls: "bg-emerald-100 text-emerald-800" },
};

export function VerificationBadge({ status, className = "" }) {
  const b = VERIF_BADGES[status] || VERIF_BADGES.submitted;
  const Icon = b.icon;
  return (
    <span data-testid={`verif-badge-${status}`}
      className={`inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-xs font-medium ${b.cls} ${className}`}>
      <Icon size={13} weight="fill" /> {b.label}
    </span>
  );
}

export function AiBadge({ generated, assisted, className = "" }) {
  if (!generated && !assisted) return null;
  return (
    <span data-testid="ai-badge"
      className={`inline-flex items-center gap-1 rounded-full bg-violet-100 px-2.5 py-0.5 text-xs font-medium text-violet-800 ${className}`}>
      <Sparkle size={13} weight="fill" /> AI-assisted draft
    </span>
  );
}
